// extracted by css-extract-rspack-plugin
export default {"pagination":"pagination-mefuo3","page-info":"page-info-_y9rzT","pageInfo":"page-info-_y9rzT"};